import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-channel-affinity-report',
  templateUrl: './help-channel-affinity-report.component.html',
  styleUrls: ['./help-channel-affinity-report.component.scss']
})
export class HelpChannelAffinityReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
